import React, { useState, useEffect } from "react";
import { CartIcon, HeartIcon } from "../GetIcons";
import { useFavs } from "../../contexts/FavsProvider";
import { useAuth } from "../../contexts/AuthProvider";
import { useTelegram } from "../../hooks/useTelegram";
import Item from "../Item/Item";
import Back from "../../assets/back.svg";
import "./Favorites.scss";
import { updateFavorite, getFavoritesByUserId } from "../../router/apiServiceFetch";

const Favorites = ({ cartItems, handleRemoveFromCart, handleAddToCart }) => {
    const [selectedItem, setSelectedItem] = useState(null);
    const [gamesFavs, setGamesFavs] = useState([]);
    const { userBase } = useAuth();
    const { favs, setFavs } = useFavs();
    const { triggerHapticFeedback } = useTelegram();
    const [filteredItems, setFilteredItems] = useState([]);
    const [isVisible, setIsVisible] = useState(false);
    const [selected, setSelected] = useState(null);
    const [groups, setGroups] = useState([]);

    const filePath = process.env.REACT_APP_FILE_PATH;

    const fetchFavorites = async () => {
        try {
            const fetchedGames = await getFavoritesByUserId(userBase.userId);
            if (!fetchedGames) {
                console.warn("No data received for favorites.");
                setGamesFavs([]);
                return;
            }

            // Ensure fetchedGames is always an array
            const gamesArray = Array.isArray(fetchedGames) ? fetchedGames : [fetchedGames];

            // Map data: Flatten items from all gameGroups into a single array
            const mapGameData = (games) =>
                games.map((game) => ({
                    name: game.name,
                    gameId: game.gameId,
                    // Flatten all items from all groups into one items array
                    items: game.gameGroups?.flatMap((group) => group.items) || []
                }));

            setGamesFavs(mapGameData(gamesArray));
        } catch (error) {
            console.error("Error fetching games data:", error);
        }
    };

    useEffect(() => {
        fetchFavorites();
    }, [userBase.userId]);

    // Set groups and initial selection after gamesFavs is loaded
    useEffect(() => {
        if (!gamesFavs || gamesFavs.length === 0) {
            setGroups([]);
            setSelected(null);
            setFilteredItems([]);
            return;
        }

        // Each game is treated as a "group" for filtering
        const newGroups = gamesFavs.map((game) => ({
            name: game.name,
            id: game.gameId
        }));

        setGroups(newGroups);

        // Automatically select the first group if available
        if (newGroups.length > 0) {
            setSelected(newGroups[0].id);
        } else {
            setSelected(null);
        }
    }, [gamesFavs]);

    // Filter and sort items whenever `selected` or `gamesFavs` changes
    useEffect(() => {
        let items = [];

        if (selected) {
            // If a specific game is selected, filter items from that game
            const selectedGame = gamesFavs.find((game) => game.gameId === selected);
            items = selectedGame ? [...selectedGame.items] : [];
        } else {
            // If no game is selected, combine items from all games
            items = gamesFavs.flatMap((game) => game.items);
        }

        // Sort items: Popular first, then New, then by sort order
        items.sort((a, b) => {
            if (a.isPopular !== b.isPopular) return b.isPopular - a.isPopular; // Popular first
            if (a.isNew !== b.isNew) return b.isNew - a.isNew; // New next
            return a.sort - b.sort; // Finally by 'sort' value
        });

        setFilteredItems(items);
    }, [selected, gamesFavs]);

    useEffect(() => {
        const timeout = setTimeout(() => {
            setIsVisible(true);
        }, 10);
        return () => clearTimeout(timeout);
    }, []);

    const handleClose = () => {
        setFavs(0);
        setIsVisible(false);
    };


    const formatCurrency = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
            minimumFractionDigits: 2,
        }).format(number) + " руб";
    };
    const formatCurrencyDisc = (number) => {
        return new Intl.NumberFormat("ru-RU", {
            currency: "RUB",
        }).format(number);
    };

    const handleAdd = (item) => {
        handleAddToCart(item);
    };

    const handleRemove = (item) => {
        handleRemoveFromCart(item);
    };

    const handleFav = async (item) => {
        // Remove item from filteredItems
        const updatedItems = filteredItems.filter(
            (gameItem) => gameItem.itemId !== item.itemId
        );
        setFilteredItems(updatedItems);

        try {
            await updateFavorite(userBase.userId, item.itemId);
        } catch (error) {
            console.error("Error updating favorite:", error);
        }
    };

    const handleGameItemClick = (item) => {
        triggerHapticFeedback("impact", "medium");
        setSelectedItem(item); // Set the clicked item as the selected item
    };


    // Close the Item detail view
    const handleItemClose = () => {
        setSelectedItem(null);
    };
    return (
        <div className={`favorites-cont ${isVisible ? "visible" : ""}`}>
            {gamesFavs.length === 0 &&
                <div className="no-items">
                    <HeartIcon fillColor="#FFFFFF40" className="no-items-svg" />
                </div>
            }
            {selectedItem ? (
                <Item gameItem={selectedItem} onClose={handleItemClose} />
            ) : (
                <div className="allItems">
                    <div className="nav">
                        <div className="back-nav">
                            <div className="back-btn" onClick={handleClose}>
                                <button>
                                    <img src={Back} alt="back" />
                                </button>
                            </div>
                            <h2>Избранные</h2>
                        </div>
                    </div>
                    <div className="allItems-content">
                        {filteredItems.length > 0 &&
                            <>
                                {groups.length > 0 && (
                                    <div className="game-nav">
                                        <div className="game-nav-cont">
                                            {groups.map((game) => (
                                                <button
                                                    key={game.id}
                                                    className={selected === game.id ? "active" : ""}
                                                    onClick={() => {
                                                        setSelected(game.id);
                                                        triggerHapticFeedback('impact', 'medium');
                                                    }}
                                                >
                                                    {game.name}
                                                </button>
                                            ))}
                                        </div>
                                    </div>
                                )}

                                <div className="gridItems">
                                    {filteredItems.map((item, index) => {
                                        const cartItem = cartItems.find(
                                            (cartItem) => cartItem.itemId === item.itemId
                                        );
                                        return (
                                            <div className="gameSlide" key={index}>
                                                <div className="gameSlide-inner">
                                                    <img
                                                        src={`${filePath}/Games/${item.fileName}`}
                                                        alt={item.name}
                                                        className="slideImage"
                                                        onClick={() => handleGameItemClick(item)}
                                                    />
                                                    <div
                                                        className={`heartIcon ${item.isFav ? "isActiveFave" : ""}`}
                                                        onClick={() => handleFav(item)}
                                                    >

                                                        <HeartIcon fillColor={item.isFav ? "#4A0073" : "#fff"} stroke={item.isFav ? "#8E00DD " : "none"} />
                                                    </div>
                                                    {item.isNew && <p className="isNew">НОВИНКА</p>}
                                                    {item.isPopular && <p className="isPopular">Популярная</p>}
                                                    <div className="gameSliderText"
                                                        onClick={() => handleGameItemClick(item)}>
                                                        <h3>{item.name}</h3>
                                                        <div>
                                                            <p>
                                                                {formatCurrency(item.priceAfterDiscount)}
                                                            </p>
                                                            {item.discount > 0 && <span className="disc">-{item.discount}%</span>}
                                                        </div>
                                                    </div>
                                                    {cartItem ? (
                                                        <div className="gameSliderBtnDiv">
                                                            <div className="gameSliderButtons">
                                                                <button onClick={() => handleRemove(item)}>
                                                                    -
                                                                </button>
                                                            </div>
                                                            <p className="quantity">{cartItem.quantity}</p>
                                                            <div className="gameSliderButtons">
                                                                <button onClick={() => handleAdd(item)}>
                                                                    +
                                                                </button>
                                                            </div>
                                                        </div>
                                                    ) : (
                                                        <div className="gameSliderBtn">
                                                            <button onClick={() => handleAdd(item)}>
                                                                В Корзину
                                                                <CartIcon fillColor="#FFAA00" />
                                                            </button>
                                                        </div>
                                                    )}
                                                </div>
                                            </div>
                                        );
                                    })}
                                </div>
                            </>
                        }
                    </div>
                </div>
            )}
        </div>
    );
};

export default Favorites;
